import { useContext } from 'react';

import { UserInfoContext } from './user-info-context';

export const useUserInfo = () => useContext(UserInfoContext);
